<template>
  <div class="error">
    <div class="error-content"></div>
  </div>
</template>

<script>
export default {
  name: "error",
};
</script>
<style scoped>
.error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('@/assets/images/bg.jpg') no-repeat center center;
  background-size:cover;
}
.error-content {
  width: 1894px;
  height: 924px;
  background: url('@/assets/images/404.png') no-repeat center center;
  background-size: 100% auto;
}

@media (max-width: 1920px) {
  .error-content {
    width: 1440px;
    height: 720px;
  }
}

@media (max-width: 1440px) {
  .error-content {
    width: 1024px;
    height: 576px;
  }
}

@media (max-width: 1024px) {
  .error-content {
    width: 768px;
    height: 432px;
  }
}

@media (max-width: 768px) {
  .error-content {
    width: 375px;
    height: 216px;
  }}
</style>